import { Component, Inject, OnInit } from "@angular/core";
import { FormControl, FormGroup } from "@angular/forms";
import { MatDialogRef, MAT_DIALOG_DATA } from "@angular/material/dialog";
import { CommonService } from "src/app/services/common.service";
import * as moment from 'moment';

enum typeEnum {
  note = "note",
  request = "request",
  urgentTask = "urgentTask"
}
@Component({
  selector: "fury-view-note-modal",
  templateUrl: "./view-note-modal.component.html",
  styleUrls: ["./view-note-modal.component.scss"],
})
export class ViewNoteModalComponent implements OnInit {
  modalHeading = {
    note: 'View Note',
    request: 'View Request',
    urgentTask: 'View Urgent Task'
  }
  noteForm = new FormGroup({
    assigned: new FormControl(null),
    agreementNumber: new FormControl(null),
    notes: new FormControl(null),
    priority: new FormControl(null),
    status: new FormControl(null),
  });
  specialRequestForm = new FormGroup({
    assigned: new FormControl(null),
    agreementNumber: new FormControl(null),
    request: new FormControl(null),
    status: new FormControl(null),
    type: new FormControl(null),
    priority: new FormControl(null),
  });
  urgentTaskForm = new FormGroup({
    note: new FormControl(null),
    status: new FormControl(null),
    createdAt: new FormControl(null),
    agentName: new FormControl(null),
    emailAddress: new FormControl(null)
  })
  constructor(
    public dialogRef: MatDialogRef<ViewNoteModalComponent>,
    @Inject(MAT_DIALOG_DATA) public data: { rowData: any; type: typeEnum },
    private commonService: CommonService
  ) {}

  ngOnInit(): void {
    this.patchFormValue();
  }
  patchFormValue(){
    if(this.data.type === typeEnum.note){
      this.noteForm.disable();
      this.noteForm.patchValue({
        status: this.data.rowData?.status,
        assigned: `${this.data?.rowData?.assigned?.firstName} ${this.data?.rowData?.assigned?.lastName}`,
        agreementNumber: this.data?.rowData?.agreementNumber,
        priority: this.data?.rowData?.priority,
        notes: this.data?.rowData?.notes
      })
    }
    if(this.data.type === typeEnum.request){
      this.specialRequestForm.disable();
      this.specialRequestForm.patchValue({
        status: this.data.rowData?.status,
        agreementNumber: this.data.rowData?.agreementNumber,
        type: this.data.rowData?.type,
        priority: this.data.rowData?.priority,
        assigned: `${this.data.rowData?.assigned?.firstName} ${this.data.rowData?.assigned?.lastName}`,
        request: this.data.rowData?.request
      })
    }
    if(this.data.type === typeEnum.urgentTask){
      this.urgentTaskForm.disable();
      this.urgentTaskForm.patchValue({
        note: this.data.rowData?.note,
        status: this.data.rowData?.status,
        createdAt: moment(this.commonService.convertDate(this.data.rowData?.createdAt)).format('MMM DD, YYYY HH:mm:ss'),
        agentName: `${this.data.rowData?.agentDetail?.firstName} ${this.data.rowData?.agentDetail?.lastName}`,
        emailAddress: this.data.rowData?.agentDetail?.emailAddress,
      })
    }
  }
  close() {
    this.dialogRef.close();
  }
}
